module.exports = __webpack_public_path__ + "static/media/double-check-unread.16ab6eea.svg";